document.addEventListener('DOMContentLoaded', function (){
    if (document.querySelector('.rotating-text-bar') && document.querySelector('popup-overlay')) {
        const links = document.querySelectorAll('.rotating-text-item a');

        links.forEach(function (item) {

           if (item.getAttribute('href') === 'https://klifex.net#promo_popup') {
               item.addEventListener('click', function (event) {
                   event.preventDefault();

                   const popup = document.querySelector('popup-overlay');
                   popup.setAttribute('open', true);
               })
           }
        });
    }

    if (document.querySelector('.product-info-description-content')){
        const textBlock = document.querySelector('.product-info-description-content collapsible-expandable[data-content=description] .facet-content');
        const toggleButton = document.querySelector('.facet-content__read-more');

        const lineHeight = parseFloat(getComputedStyle(textBlock).lineHeight);
        const maxLines = 5;

        if (textBlock.scrollHeight > lineHeight * maxLines) {
            toggleButton.style.display = 'inline-block';
        }

        const buttonText = {
            en: {
                hide: 'Hide',
                read_all: 'Read All'
            },

            es: {
                hide: 'Ocultar',
                read_all: 'Ver todo'
            }

        }

        let currentLanguage = {};

        if (document.querySelector('html[lang="es"]')) {
            currentLanguage = buttonText.es;
        } else {
            currentLanguage = buttonText.en;
        }

        toggleButton.textContent = textBlock.classList.contains('expanded') ? currentLanguage.hide : currentLanguage.read_all;

        toggleButton.addEventListener('click', () => {
            textBlock.classList.toggle('expanded');
            toggleButton.textContent = textBlock.classList.contains('expanded') ? currentLanguage.hide : currentLanguage.read_all;
        });
    }

});